import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 50, width: 100, mr: 2 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="svg1"
        width="444.579"
        height="402.929"
        version="1.1"
        viewBox="0 0 444.579 402.929"
      >
        <defs id="defs1">
          <clipPath id="clipPath268" clipPathUnits="userSpaceOnUse">
            <path
              id="path268"
              d="M0 500h1000V0H0Z"
              transform="translate(-637.896 -238.589)"
            ></path>
          </clipPath>
          <clipPath id="clipPath270" clipPathUnits="userSpaceOnUse">
            <path
              id="path270"
              d="M0 500h1000V0H0Z"
              transform="translate(-870.524 -349.076)"
            ></path>
          </clipPath>
          <clipPath id="clipPath272" clipPathUnits="userSpaceOnUse">
            <path
              id="path272"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.17 -336.862)"
            ></path>
          </clipPath>
          <clipPath id="clipPath275" clipPathUnits="userSpaceOnUse">
            <path
              id="path275"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -113.341)"
            ></path>
          </clipPath>
          <clipPath id="clipPath277" clipPathUnits="userSpaceOnUse">
            <path
              id="path277"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -117.454)"
            ></path>
          </clipPath>
          <clipPath id="clipPath279" clipPathUnits="userSpaceOnUse">
            <path
              id="path279"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -121.566)"
            ></path>
          </clipPath>
          <clipPath id="clipPath281" clipPathUnits="userSpaceOnUse">
            <path
              id="path281"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -125.678)"
            ></path>
          </clipPath>
          <clipPath id="clipPath283" clipPathUnits="userSpaceOnUse">
            <path
              id="path283"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -105.114)"
            ></path>
          </clipPath>
          <clipPath id="clipPath285" clipPathUnits="userSpaceOnUse">
            <path
              id="path285"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -109.229)"
            ></path>
          </clipPath>
          <clipPath id="clipPath287" clipPathUnits="userSpaceOnUse">
            <path
              id="path287"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -121.714)"
            ></path>
          </clipPath>
          <clipPath id="clipPath289" clipPathUnits="userSpaceOnUse">
            <path
              id="path289"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -125.826)"
            ></path>
          </clipPath>
          <clipPath id="clipPath291" clipPathUnits="userSpaceOnUse">
            <path
              id="path291"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -113.49)"
            ></path>
          </clipPath>
          <clipPath id="clipPath293" clipPathUnits="userSpaceOnUse">
            <path
              id="path293"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -105.265)"
            ></path>
          </clipPath>
          <clipPath id="clipPath295" clipPathUnits="userSpaceOnUse">
            <path
              id="path295"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -109.377)"
            ></path>
          </clipPath>
          <clipPath id="clipPath297" clipPathUnits="userSpaceOnUse">
            <path
              id="path297"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -117.602)"
            ></path>
          </clipPath>
          <clipPath id="clipPath299" clipPathUnits="userSpaceOnUse">
            <path
              id="path299"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -117.898)"
            ></path>
          </clipPath>
          <clipPath id="clipPath301" clipPathUnits="userSpaceOnUse">
            <path
              id="path301"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -126.122)"
            ></path>
          </clipPath>
          <clipPath id="clipPath303" clipPathUnits="userSpaceOnUse">
            <path
              id="path303"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -122.01)"
            ></path>
          </clipPath>
          <clipPath id="clipPath305" clipPathUnits="userSpaceOnUse">
            <path
              id="path305"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -113.785)"
            ></path>
          </clipPath>
          <clipPath id="clipPath307" clipPathUnits="userSpaceOnUse">
            <path
              id="path307"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -109.673)"
            ></path>
          </clipPath>
          <clipPath id="clipPath309" clipPathUnits="userSpaceOnUse">
            <path
              id="path309"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -105.558)"
            ></path>
          </clipPath>
          <clipPath id="clipPath311" clipPathUnits="userSpaceOnUse">
            <path
              id="path311"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -118.045)"
            ></path>
          </clipPath>
          <clipPath id="clipPath313" clipPathUnits="userSpaceOnUse">
            <path
              id="path313"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -126.271)"
            ></path>
          </clipPath>
          <clipPath id="clipPath315" clipPathUnits="userSpaceOnUse">
            <path
              id="path315"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -122.158)"
            ></path>
          </clipPath>
          <clipPath id="clipPath317" clipPathUnits="userSpaceOnUse">
            <path
              id="path317"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -113.933)"
            ></path>
          </clipPath>
          <clipPath id="clipPath319" clipPathUnits="userSpaceOnUse">
            <path
              id="path319"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -109.82)"
            ></path>
          </clipPath>
          <clipPath id="clipPath321" clipPathUnits="userSpaceOnUse">
            <path
              id="path321"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -105.707)"
            ></path>
          </clipPath>
          <clipPath id="clipPath323" clipPathUnits="userSpaceOnUse">
            <path
              id="path323"
              d="M0 500h1000V0H0Z"
              transform="translate(-797.094 -127.9)"
            ></path>
          </clipPath>
          <clipPath id="clipPath325" clipPathUnits="userSpaceOnUse">
            <path
              id="path325"
              d="M0 500h1000V0H0Z"
              transform="translate(-797.094 -130.849)"
            ></path>
          </clipPath>
          <clipPath id="clipPath327" clipPathUnits="userSpaceOnUse">
            <path
              id="path327"
              d="M0 500h1000V0H0Z"
              transform="translate(-799.28 -128.037)"
            ></path>
          </clipPath>
          <clipPath id="clipPath329" clipPathUnits="userSpaceOnUse">
            <path
              id="path329"
              d="M0 500h1000V0H0Z"
              transform="translate(-799.28 -130.985)"
            ></path>
          </clipPath>
          <clipPath id="clipPath331" clipPathUnits="userSpaceOnUse">
            <path
              id="path331"
              d="M0 500h1000V0H0Z"
              transform="translate(-801.467 -131.26)"
            ></path>
          </clipPath>
          <clipPath id="clipPath333" clipPathUnits="userSpaceOnUse">
            <path
              id="path333"
              d="M0 500h1000V0H0Z"
              transform="translate(-801.467 -128.31)"
            ></path>
          </clipPath>
          <clipPath id="clipPath335" clipPathUnits="userSpaceOnUse">
            <path
              id="path335"
              d="M0 500h1000V0H0Z"
              transform="translate(-803.929 -131.397)"
            ></path>
          </clipPath>
          <clipPath id="clipPath337" clipPathUnits="userSpaceOnUse">
            <path
              id="path337"
              d="M0 500h1000V0H0Z"
              transform="translate(-803.929 -128.447)"
            ></path>
          </clipPath>
          <clipPath id="clipPath340" clipPathUnits="userSpaceOnUse">
            <path
              id="path340"
              d="M0 500h1000V0H0Z"
              transform="translate(-772.347 -122.77)"
            ></path>
          </clipPath>
          <clipPath id="clipPath342" clipPathUnits="userSpaceOnUse">
            <path
              id="path342"
              d="M0 500h1000V0H0Z"
              transform="translate(-788.338 -104.215)"
            ></path>
          </clipPath>
          <clipPath id="clipPath344" clipPathUnits="userSpaceOnUse">
            <path
              id="path344"
              d="M0 500h1000V0H0Z"
              transform="translate(-788.295 -131.607)"
            ></path>
          </clipPath>
          <linearGradient
            id="linearGradient262"
            x1="0"
            x2="1"
            y1="0"
            y2="0"
            gradientTransform="matrix(187.64043 0 0 -187.64043 645.721 237.972)"
            gradientUnits="userSpaceOnUse"
            spreadMethod="pad"
          >
            <stop
              id="stop259"
              offset="0"
              stopColor="#07a1e5"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop260"
              offset="0.511"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop261"
              offset="0.763"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop262"
              offset="1"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
          </linearGradient>
          <linearGradient
            id="linearGradient266"
            x1="0"
            x2="1"
            y1="0"
            y2="0"
            gradientTransform="matrix(187.64565 0 0 -187.64565 674.898 324.986)"
            gradientUnits="userSpaceOnUse"
            spreadMethod="pad"
          >
            <stop
              id="stop263"
              offset="0"
              stopColor="#07a1e5"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop264"
              offset="0.511"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop265"
              offset="0.763"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop266"
              offset="1"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
          </linearGradient>
          <color-profile
            xlinkHref="data:application/vnd.iccprofile;base64,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"
            id="color-profile1"
            name="sRGB IEC61966-2.1"
          ></color-profile>
        </defs>
        <g
          id="layer-MC0"
          stroke="none"
          transform="translate(-2136.552 -125.575)"
        >
          <path
            id="path262"
            fill="url(#linearGradient262)"
            d="M649.946 318.006c-2.482-.524-4.225-2.769-4.225-5.306v-90.668a5.44 5.44 0 0 1 2.722-4.714l10.406-6.007 11.721-6.769 80.843-46.673a5.44 5.44 0 0 1 5.442 0l75.392 43.529c1.655.955 1.418 3.414-.388 4.036l-6.668 2.297a78 78 0 0 0-16.674 8.094c-.211.137-.413.291-.624.431l-51.038-29.47a5.44 5.44 0 0 0-5.442 0l-51.043 29.47-7.697 4.444-19.188 11.078a5.44 5.44 0 0 0-2.72 4.713v75.914a5.45 5.45 0 0 1-4.109 5.286 37.2 37.2 0 0 1-9.047 1.113c-2.627 0-5.189-.277-7.663-.798"
            transform="matrix(1.33333 0 0 -1.33333 1353.333 666.667)"
          ></path>
          <path
            id="path266"
            fill="url(#linearGradient266)"
            d="m751.413 405.09-75.4-43.534c-1.656-.955-1.419-3.414.388-4.035l6.675-2.297a77.7 77.7 0 0 0 16.674-8.097c.209-.135.409-.289.617-.425l51.046 29.469a5.44 5.44 0 0 0 5.442 0l51.043-29.468 7.696-4.445 19.184-11.075a5.44 5.44 0 0 0 2.721-4.713v-79.903c.324-.122.642-.255.969-.367a37.3 37.3 0 0 1 12.185-2.046c2.63 0 5.193.277 7.667.8 2.482.524 4.224 2.769 4.224 5.305v90.668a5.45 5.45 0 0 1-2.721 4.714l-10.405 6.006-11.723 6.77-80.84 46.673a5.438 5.438 0 0 1-5.442 0"
            transform="matrix(1.33333 0 0 -1.33333 1353.333 666.667)"
          ></path>
          <path
            id="path267"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a3.72 3.72 0 0 1-1.917 3.269c-14.004 7.675-23.522 22.556-23.522 39.62 0 17.835 10.394 33.281 25.439 40.615a45 45 0 0 0 7.825 2.938 45 45 0 0 0 11.888 1.599c4.47 0 8.881-.695 13.155-2 .531-.162 1.066-.295 1.589-.476a45 45 0 0 0 6.238-2.723 46 46 0 0 0 3.383-1.949 46 46 0 0 0 4.912-3.646L86.425 49.43a3.76 3.76 0 0 1 4.481-.001l14.699 10.91c2.024 1.502 2.024 4.532 0 6.035L64.893 96.595a71 71 0 0 1-2.843 2.239 70 70 0 0 1-4.432 3.123 67 67 0 0 1-2.845 1.711 69.6 69.6 0 0 1-12.148 5.57 70 70 0 0 1-21.673 3.821c-.413.006-.826.025-1.239.025a70 70 0 0 1-18.866-2.596c-29.57-8.264-51.329-35.429-51.329-67.599 0-32.169 20.761-59.334 50.329-67.597l.153.491Z"
            clipPath="url(#clipPath268)"
            transform="matrix(1.33333 0 0 -1.33333 2203.862 348.549)"
          ></path>
          <path
            id="path269"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-.155-.489v-24.219c0-1.357.727-2.618 1.917-3.27 14.004-7.675 23.522-22.556 23.522-39.621 0-17.831-10.394-33.279-25.439-40.611a44.6 44.6 0 0 0-7.825-2.938 45 45 0 0 0-11.89-1.601c-4.472 0-8.881.697-13.155 1.999-.527.163-1.062.296-1.585.475a45 45 0 0 0-6.24 2.725 44 44 0 0 0-3.378 1.947 45 45 0 0 0-4.911 3.646L-86.58-74.138a3.76 3.76 0 0 1-4.481.001l-14.7-10.91c-2.025-1.503-2.025-4.533-.001-6.035l40.71-30.216c.921-.777 1.882-1.513 2.843-2.244a72 72 0 0 1 4.434-3.125 69 69 0 0 1 2.845-1.709 70 70 0 0 1 12.152-5.573 70 70 0 0 1 21.669-3.816c.413-.009.826-.028 1.239-.028a70 70 0 0 1 18.866 2.597c29.57 8.263 51.329 35.428 51.329 67.597S29.568-8.266 0 0"
            clipPath="url(#clipPath270)"
            transform="matrix(1.33333 0 0 -1.33333 2514.032 201.231)"
          ></path>
          <path
            id="path271"
            fill="#fe9900"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0 20.467-11.45c1.511-.846 1.651-2.966.265-4.003l-129.043-96.546a2.39 2.39 0 0 0-2.677-.128l-19.055 11.609a2.393 2.393 0 0 0-.197 3.952L-2.609-.179A2.39 2.39 0 0 0 0 0"
            clipPath="url(#clipPath272)"
            transform="matrix(1.33333 0 0 -1.33333 2432.227 217.517)"
          ></path>
          <path
            id="path273"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M16.08.001v-22.805h10.487v-4.828H.763v4.828H11.25V.001Zm37.423 0v-4.828h-19.91v-17.977h19.875v-4.828H28.8V.001Zm-1.067-12.012v-4.066H37.132v4.066zM84.291.001v-4.828H69.314c-4.98 0-8.59-3.832-8.59-9.047 0-5.238 3.645-8.93 8.59-8.93h14.977v-4.828H69.314c-7.71 0-13.418 5.403-13.418 13.535C55.896-6.08 61.603.001 69.314.001zm30.012.117v-27.75h-4.828v11.438H95.576v4.3h13.899V.118Zm-22.23 0v-27.75h-4.829V.118zm0 0"
            ariaLabel="TECH"
            transform="matrix(1.33333 0 0 1.33333 2424.547 528.092)"
          ></path>
          <path
            id="path274"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath275)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 515.545)"
          ></path>
          <path
            id="path276"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath277)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 510.062)"
          ></path>
          <path
            id="path278"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath279)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 504.579)"
          ></path>
          <path
            id="path280"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 0-.592A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath281)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 499.096)"
          ></path>
          <path
            id="path282"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 0-.592A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath283)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 526.515)"
          ></path>
          <path
            id="path284"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 .296-.296A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath285)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 521.028)"
          ></path>
          <path
            id="path286"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath287)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 504.381)"
          ></path>
          <path
            id="path288"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.443.443 0 1 1 0-.888A.445.445 0 0 1 0 0"
            clipPath="url(#clipPath289)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 498.898)"
          ></path>
          <path
            id="path290"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath291)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 515.348)"
          ></path>
          <path
            id="path292"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.445.445 0 1 1 .002-.89A.445.445 0 0 1 0 0"
            clipPath="url(#clipPath293)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 526.313)"
          ></path>
          <path
            id="path294"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath295)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 520.83)"
          ></path>
          <path
            id="path296"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath297)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 509.865)"
          ></path>
          <path
            id="path298"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath299)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 509.47)"
          ></path>
          <path
            id="path300"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 1 0-1.48A.74.74 0 0 1 0 0"
            clipPath="url(#clipPath301)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 498.504)"
          ></path>
          <path
            id="path302"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath303)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 503.987)"
          ></path>
          <path
            id="path304"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath305)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 514.953)"
          ></path>
          <path
            id="path306"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath307)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 520.436)"
          ></path>
          <path
            id="path308"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 0 1-.74-.74c0-.409.331-.737.74-.737s.74.328.74.737A.74.74 0 0 1 0 0"
            clipPath="url(#clipPath309)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 525.923)"
          ></path>
          <path
            id="path310"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.887.887 0 1 0 .001-1.775A.887.887 0 0 0 0 0"
            clipPath="url(#clipPath311)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 509.273)"
          ></path>
          <path
            id="path312"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.889.889 0 1 1 .002-1.778A.889.889 0 0 1 0 0"
            clipPath="url(#clipPath313)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 498.305)"
          ></path>
          <path
            id="path314"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.888.888 0 1 0 0-1.776A.888.888 0 0 0 0 0"
            clipPath="url(#clipPath315)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 503.79)"
          ></path>
          <path
            id="path316"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.888.888 0 1 0 0-1.776A.888.888 0 0 0 0 0"
            clipPath="url(#clipPath317)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 514.756)"
          ></path>
          <path
            id="path318"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.887.887 0 1 0 .001-1.775A.887.887 0 0 0 0 0"
            clipPath="url(#clipPath319)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 520.24)"
          ></path>
          <path
            id="path320"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.89.89 0 0 1-.888-.89c0-.491.398-.886.888-.886.491 0 .888.395.888.886A.89.89 0 0 1 0 0"
            clipPath="url(#clipPath321)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 525.724)"
          ></path>
          <path
            id="path322"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.275.275 0 0 1-.274-.274.274.274 0 0 1 .548 0A.274.274 0 0 1 0 0"
            clipPath="url(#clipPath323)"
            transform="matrix(1.33333 0 0 -1.33333 2416.126 496.133)"
          ></path>
          <path
            id="path324"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.273.273 0 1 1 0-.547c.151 0 .274.123.274.273A.273.273 0 0 1 0 0"
            clipPath="url(#clipPath325)"
            transform="matrix(1.33333 0 0 -1.33333 2416.126 492.202)"
          ></path>
          <path
            id="path326"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.41.41 0 1 0 0-.82A.41.41 0 0 0 0 0"
            clipPath="url(#clipPath327)"
            transform="matrix(1.33333 0 0 -1.33333 2419.04 495.95)"
          ></path>
          <path
            id="path328"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.411.411 0 0 1 0-.821A.411.411 0 0 1 0 0"
            clipPath="url(#clipPath329)"
            transform="matrix(1.33333 0 0 -1.33333 2419.04 492.02)"
          ></path>
          <path
            id="path330"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.684.684 0 1 1 0-1.367A.684.684 0 0 1 0 0"
            clipPath="url(#clipPath331)"
            transform="matrix(1.33333 0 0 -1.33333 2421.956 491.655)"
          ></path>
          <path
            id="path332"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.684.684 0 1 0 0-1.367A.684.684 0 0 0 0 0"
            clipPath="url(#clipPath333)"
            transform="matrix(1.33333 0 0 -1.33333 2421.956 495.586)"
          ></path>
          <path
            id="path334"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.82.82 0 0 1-.821-.822A.82.82 0 0 1 0-1.641.82.82 0 0 1 0 0"
            clipPath="url(#clipPath335)"
            transform="matrix(1.33333 0 0 -1.33333 2425.238 491.47)"
          ></path>
          <path
            id="path336"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.82.82 0 1 0 0-1.64A.82.82 0 0 0 0 0"
            clipPath="url(#clipPath337)"
            transform="matrix(1.33333 0 0 -1.33333 2425.238 495.404)"
          ></path>
          <path
            id="path338"
            fill="#777"
            fillOpacity="1"
            fillRule="nonzero"
            d="M37.02 0 21.094-26.448c-.574-.949-1.254-1.558-2.32-1.558-1.067 0-1.782.61-2.356 1.558L.528.001h5.519L18.586-21.21l6.152 10.347h-8.472L13.98-6.949H27.06l4.136 6.95zM55.03 0c7.782 0 13.453-6.082 13.453-14.097s-5.671-13.535-13.453-13.535H39.023V0ZM43.816-4.827v-17.976h11.215c4.969 0 8.625 3.726 8.625 8.93 0 5.214-3.656 9.046-8.625 9.046zM102.42.001 86.493-26.45c-.574-.949-1.254-1.558-2.32-1.558-1.067 0-1.781.61-2.356 1.558L65.927.001h5.52L83.984-21.21l6.153 10.347h-8.473L79.38-6.949h13.078l4.137 6.95Zm21.419-7.676c6.387 0 10.113-4.102 10.113-10.067 0-6.047-3.726-9.89-10.113-9.89H104.42V0h4.793v-22.805h14.625c3.387 0 5.402 2.015 5.402 5.203 0 3.117-2.015 5.25-5.402 5.25h-11.086v4.676zM150.105 0v-22.805h10.489v-4.828h-25.805v4.828h10.488V0Zm17.819 0v-27.633h-4.828V0Zm0 0"
            ariaLabel="ADAPTI"
            transform="matrix(1.33333 0 0 1.33333 2137.4 528.503)"
          ></path>
          <path
            id="path339"
            fill="#777"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-2.886-3.486-8.709 10.487-1.46 1.769.636.017 4.279.001c.143-.001.745.04.836-.007.05-.025.124-.136.163-.183l.429-.515L-4.5 5.409l2.678-3.213Z"
            clipPath="url(#clipPath340)"
            transform="matrix(1.33333 0 0 -1.33333 2383.129 502.973)"
          ></path>
          <path
            id="path341"
            fill="#777"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-6.005-.004-7.077 8.6 1.459 1.715 1.577 1.858c.256-.195.522-.609.74-.873l1.647-1.986 4.331-5.235Z"
            clipPath="url(#clipPath342)"
            transform="matrix(1.33333 0 0 -1.33333 2404.45 527.713)"
          ></path>
          <path
            id="path343"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-16.566-19.644-2.672-3.163-3.227-3.849-.52-.599c-.026-.028-.094-.124-.125-.138-.05-.024-.199 0-.258 0l-.825.001-4.804.006.382.464 7.484 8.837L-7.162-1.566-6.106-.33c.06.07.213.299.282.333C-5.736.047-.479 0 0 0"
            clipPath="url(#clipPath344)"
            transform="matrix(1.33333 0 0 -1.33333 2404.394 491.19)"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  );
}

export function CompanyLogoLight() {
  return (
    <SvgIcon sx={{ height: 80, width: 100, mr: 2 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="svg1"
        width="444.579"
        height="402.929"
        version="1.1"
        viewBox="0 0 444.579 402.929"
      >
        <defs id="defs1">
          <clipPath id="clipPath268" clipPathUnits="userSpaceOnUse">
            <path
              id="path268"
              d="M0 500h1000V0H0Z"
              transform="translate(-637.896 -238.589)"
            ></path>
          </clipPath>
          <clipPath id="clipPath270" clipPathUnits="userSpaceOnUse">
            <path
              id="path270"
              d="M0 500h1000V0H0Z"
              transform="translate(-870.524 -349.076)"
            ></path>
          </clipPath>
          <clipPath id="clipPath272" clipPathUnits="userSpaceOnUse">
            <path
              id="path272"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.17 -336.862)"
            ></path>
          </clipPath>
          <clipPath id="clipPath275" clipPathUnits="userSpaceOnUse">
            <path
              id="path275"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -113.341)"
            ></path>
          </clipPath>
          <clipPath id="clipPath277" clipPathUnits="userSpaceOnUse">
            <path
              id="path277"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -117.454)"
            ></path>
          </clipPath>
          <clipPath id="clipPath279" clipPathUnits="userSpaceOnUse">
            <path
              id="path279"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -121.566)"
            ></path>
          </clipPath>
          <clipPath id="clipPath281" clipPathUnits="userSpaceOnUse">
            <path
              id="path281"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -125.678)"
            ></path>
          </clipPath>
          <clipPath id="clipPath283" clipPathUnits="userSpaceOnUse">
            <path
              id="path283"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -105.114)"
            ></path>
          </clipPath>
          <clipPath id="clipPath285" clipPathUnits="userSpaceOnUse">
            <path
              id="path285"
              d="M0 500h1000V0H0Z"
              transform="translate(-807.213 -109.229)"
            ></path>
          </clipPath>
          <clipPath id="clipPath287" clipPathUnits="userSpaceOnUse">
            <path
              id="path287"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -121.714)"
            ></path>
          </clipPath>
          <clipPath id="clipPath289" clipPathUnits="userSpaceOnUse">
            <path
              id="path289"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -125.826)"
            ></path>
          </clipPath>
          <clipPath id="clipPath291" clipPathUnits="userSpaceOnUse">
            <path
              id="path291"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -113.49)"
            ></path>
          </clipPath>
          <clipPath id="clipPath293" clipPathUnits="userSpaceOnUse">
            <path
              id="path293"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -105.265)"
            ></path>
          </clipPath>
          <clipPath id="clipPath295" clipPathUnits="userSpaceOnUse">
            <path
              id="path295"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -109.377)"
            ></path>
          </clipPath>
          <clipPath id="clipPath297" clipPathUnits="userSpaceOnUse">
            <path
              id="path297"
              d="M0 500h1000V0H0Z"
              transform="translate(-809.578 -117.602)"
            ></path>
          </clipPath>
          <clipPath id="clipPath299" clipPathUnits="userSpaceOnUse">
            <path
              id="path299"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -117.898)"
            ></path>
          </clipPath>
          <clipPath id="clipPath301" clipPathUnits="userSpaceOnUse">
            <path
              id="path301"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -126.122)"
            ></path>
          </clipPath>
          <clipPath id="clipPath303" clipPathUnits="userSpaceOnUse">
            <path
              id="path303"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -122.01)"
            ></path>
          </clipPath>
          <clipPath id="clipPath305" clipPathUnits="userSpaceOnUse">
            <path
              id="path305"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -113.785)"
            ></path>
          </clipPath>
          <clipPath id="clipPath307" clipPathUnits="userSpaceOnUse">
            <path
              id="path307"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -109.673)"
            ></path>
          </clipPath>
          <clipPath id="clipPath309" clipPathUnits="userSpaceOnUse">
            <path
              id="path309"
              d="M0 500h1000V0H0Z"
              transform="translate(-811.944 -105.558)"
            ></path>
          </clipPath>
          <clipPath id="clipPath311" clipPathUnits="userSpaceOnUse">
            <path
              id="path311"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -118.045)"
            ></path>
          </clipPath>
          <clipPath id="clipPath313" clipPathUnits="userSpaceOnUse">
            <path
              id="path313"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -126.271)"
            ></path>
          </clipPath>
          <clipPath id="clipPath315" clipPathUnits="userSpaceOnUse">
            <path
              id="path315"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -122.158)"
            ></path>
          </clipPath>
          <clipPath id="clipPath317" clipPathUnits="userSpaceOnUse">
            <path
              id="path317"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -113.933)"
            ></path>
          </clipPath>
          <clipPath id="clipPath319" clipPathUnits="userSpaceOnUse">
            <path
              id="path319"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -109.82)"
            ></path>
          </clipPath>
          <clipPath id="clipPath321" clipPathUnits="userSpaceOnUse">
            <path
              id="path321"
              d="M0 500h1000V0H0Z"
              transform="translate(-814.608 -105.707)"
            ></path>
          </clipPath>
          <clipPath id="clipPath323" clipPathUnits="userSpaceOnUse">
            <path
              id="path323"
              d="M0 500h1000V0H0Z"
              transform="translate(-797.094 -127.9)"
            ></path>
          </clipPath>
          <clipPath id="clipPath325" clipPathUnits="userSpaceOnUse">
            <path
              id="path325"
              d="M0 500h1000V0H0Z"
              transform="translate(-797.094 -130.849)"
            ></path>
          </clipPath>
          <clipPath id="clipPath327" clipPathUnits="userSpaceOnUse">
            <path
              id="path327"
              d="M0 500h1000V0H0Z"
              transform="translate(-799.28 -128.037)"
            ></path>
          </clipPath>
          <clipPath id="clipPath329" clipPathUnits="userSpaceOnUse">
            <path
              id="path329"
              d="M0 500h1000V0H0Z"
              transform="translate(-799.28 -130.985)"
            ></path>
          </clipPath>
          <clipPath id="clipPath331" clipPathUnits="userSpaceOnUse">
            <path
              id="path331"
              d="M0 500h1000V0H0Z"
              transform="translate(-801.467 -131.26)"
            ></path>
          </clipPath>
          <clipPath id="clipPath333" clipPathUnits="userSpaceOnUse">
            <path
              id="path333"
              d="M0 500h1000V0H0Z"
              transform="translate(-801.467 -128.31)"
            ></path>
          </clipPath>
          <clipPath id="clipPath335" clipPathUnits="userSpaceOnUse">
            <path
              id="path335"
              d="M0 500h1000V0H0Z"
              transform="translate(-803.929 -131.397)"
            ></path>
          </clipPath>
          <clipPath id="clipPath337" clipPathUnits="userSpaceOnUse">
            <path
              id="path337"
              d="M0 500h1000V0H0Z"
              transform="translate(-803.929 -128.447)"
            ></path>
          </clipPath>
          <clipPath id="clipPath340" clipPathUnits="userSpaceOnUse">
            <path
              id="path340"
              d="M0 500h1000V0H0Z"
              transform="translate(-772.347 -122.77)"
            ></path>
          </clipPath>
          <clipPath id="clipPath342" clipPathUnits="userSpaceOnUse">
            <path
              id="path342"
              d="M0 500h1000V0H0Z"
              transform="translate(-788.338 -104.215)"
            ></path>
          </clipPath>
          <clipPath id="clipPath344" clipPathUnits="userSpaceOnUse">
            <path
              id="path344"
              d="M0 500h1000V0H0Z"
              transform="translate(-788.295 -131.607)"
            ></path>
          </clipPath>
          <linearGradient
            id="linearGradient262"
            x1="0"
            x2="1"
            y1="0"
            y2="0"
            gradientTransform="matrix(187.64043 0 0 -187.64043 645.721 237.972)"
            gradientUnits="userSpaceOnUse"
            spreadMethod="pad"
          >
            <stop
              id="stop259"
              offset="0"
              stopColor="#07a1e5"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop260"
              offset="0.511"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop261"
              offset="0.763"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop262"
              offset="1"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
          </linearGradient>
          <linearGradient
            id="linearGradient266"
            x1="0"
            x2="1"
            y1="0"
            y2="0"
            gradientTransform="matrix(187.64565 0 0 -187.64565 674.898 324.986)"
            gradientUnits="userSpaceOnUse"
            spreadMethod="pad"
          >
            <stop
              id="stop263"
              offset="0"
              stopColor="#07a1e5"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop264"
              offset="0.511"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop265"
              offset="0.763"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop266"
              offset="1"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
          </linearGradient>
          <color-profile
            xlinkHref="data:application/vnd.iccprofile;base64,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"
            id="color-profile1"
            name="sRGB IEC61966-2.1"
          ></color-profile>
        </defs>
        <g
          id="layer-MC0"
          stroke="none"
          transform="translate(-2136.552 -125.575)"
        >
          <path
            id="path262"
            fill="url(#linearGradient262)"
            d="M649.946 318.006c-2.482-.524-4.225-2.769-4.225-5.306v-90.668a5.44 5.44 0 0 1 2.722-4.714l10.406-6.007 11.721-6.769 80.843-46.673a5.44 5.44 0 0 1 5.442 0l75.392 43.529c1.655.955 1.418 3.414-.388 4.036l-6.668 2.297a78 78 0 0 0-16.674 8.094c-.211.137-.413.291-.624.431l-51.038-29.47a5.44 5.44 0 0 0-5.442 0l-51.043 29.47-7.697 4.444-19.188 11.078a5.44 5.44 0 0 0-2.72 4.713v75.914a5.45 5.45 0 0 1-4.109 5.286 37.2 37.2 0 0 1-9.047 1.113c-2.627 0-5.189-.277-7.663-.798"
            transform="matrix(1.33333 0 0 -1.33333 1353.333 666.667)"
          ></path>
          <path
            id="path266"
            fill="url(#linearGradient266)"
            d="m751.413 405.09-75.4-43.534c-1.656-.955-1.419-3.414.388-4.035l6.675-2.297a77.7 77.7 0 0 0 16.674-8.097c.209-.135.409-.289.617-.425l51.046 29.469a5.44 5.44 0 0 0 5.442 0l51.043-29.468 7.696-4.445 19.184-11.075a5.44 5.44 0 0 0 2.721-4.713v-79.903c.324-.122.642-.255.969-.367a37.3 37.3 0 0 1 12.185-2.046c2.63 0 5.193.277 7.667.8 2.482.524 4.224 2.769 4.224 5.305v90.668a5.45 5.45 0 0 1-2.721 4.714l-10.405 6.006-11.723 6.77-80.84 46.673a5.438 5.438 0 0 1-5.442 0"
            transform="matrix(1.33333 0 0 -1.33333 1353.333 666.667)"
          ></path>
          <path
            id="path267"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a3.72 3.72 0 0 1-1.917 3.269c-14.004 7.675-23.522 22.556-23.522 39.62 0 17.835 10.394 33.281 25.439 40.615a45 45 0 0 0 7.825 2.938 45 45 0 0 0 11.888 1.599c4.47 0 8.881-.695 13.155-2 .531-.162 1.066-.295 1.589-.476a45 45 0 0 0 6.238-2.723 46 46 0 0 0 3.383-1.949 46 46 0 0 0 4.912-3.646L86.425 49.43a3.76 3.76 0 0 1 4.481-.001l14.699 10.91c2.024 1.502 2.024 4.532 0 6.035L64.893 96.595a71 71 0 0 1-2.843 2.239 70 70 0 0 1-4.432 3.123 67 67 0 0 1-2.845 1.711 69.6 69.6 0 0 1-12.148 5.57 70 70 0 0 1-21.673 3.821c-.413.006-.826.025-1.239.025a70 70 0 0 1-18.866-2.596c-29.57-8.264-51.329-35.429-51.329-67.599 0-32.169 20.761-59.334 50.329-67.597l.153.491Z"
            clipPath="url(#clipPath268)"
            transform="matrix(1.33333 0 0 -1.33333 2203.862 348.549)"
          ></path>
          <path
            id="path269"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-.155-.489v-24.219c0-1.357.727-2.618 1.917-3.27 14.004-7.675 23.522-22.556 23.522-39.621 0-17.831-10.394-33.279-25.439-40.611a44.6 44.6 0 0 0-7.825-2.938 45 45 0 0 0-11.89-1.601c-4.472 0-8.881.697-13.155 1.999-.527.163-1.062.296-1.585.475a45 45 0 0 0-6.24 2.725 44 44 0 0 0-3.378 1.947 45 45 0 0 0-4.911 3.646L-86.58-74.138a3.76 3.76 0 0 1-4.481.001l-14.7-10.91c-2.025-1.503-2.025-4.533-.001-6.035l40.71-30.216c.921-.777 1.882-1.513 2.843-2.244a72 72 0 0 1 4.434-3.125 69 69 0 0 1 2.845-1.709 70 70 0 0 1 12.152-5.573 70 70 0 0 1 21.669-3.816c.413-.009.826-.028 1.239-.028a70 70 0 0 1 18.866 2.597c29.57 8.263 51.329 35.428 51.329 67.597S29.568-8.266 0 0"
            clipPath="url(#clipPath270)"
            transform="matrix(1.33333 0 0 -1.33333 2514.032 201.231)"
          ></path>
          <path
            id="path271"
            fill="#fe9900"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0 20.467-11.45c1.511-.846 1.651-2.966.265-4.003l-129.043-96.546a2.39 2.39 0 0 0-2.677-.128l-19.055 11.609a2.393 2.393 0 0 0-.197 3.952L-2.609-.179A2.39 2.39 0 0 0 0 0"
            clipPath="url(#clipPath272)"
            transform="matrix(1.33333 0 0 -1.33333 2432.227 217.517)"
          ></path>
          <path
            id="path273"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M16.08.001v-22.805h10.487v-4.828H.763v4.828H11.25V.001Zm37.423 0v-4.828h-19.91v-17.977h19.875v-4.828H28.8V.001Zm-1.067-12.012v-4.066H37.132v4.066zM84.291.001v-4.828H69.314c-4.98 0-8.59-3.832-8.59-9.047 0-5.238 3.645-8.93 8.59-8.93h14.977v-4.828H69.314c-7.71 0-13.418 5.403-13.418 13.535C55.896-6.08 61.603.001 69.314.001zm30.012.117v-27.75h-4.828v11.438H95.576v4.3h13.899V.118Zm-22.23 0v-27.75h-4.829V.118zm0 0"
            ariaLabel="TECH"
            transform="matrix(1.33333 0 0 1.33333 2424.547 528.092)"
          ></path>
          <path
            id="path274"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath275)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 515.545)"
          ></path>
          <path
            id="path276"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath277)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 510.062)"
          ></path>
          <path
            id="path278"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath279)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 504.579)"
          ></path>
          <path
            id="path280"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 0-.592A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath281)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 499.096)"
          ></path>
          <path
            id="path282"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 0-.592A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath283)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 526.515)"
          ></path>
          <path
            id="path284"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 .296-.296A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath285)"
            transform="matrix(1.33333 0 0 -1.33333 2429.617 521.028)"
          ></path>
          <path
            id="path286"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath287)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 504.381)"
          ></path>
          <path
            id="path288"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.443.443 0 1 1 0-.888A.445.445 0 0 1 0 0"
            clipPath="url(#clipPath289)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 498.898)"
          ></path>
          <path
            id="path290"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath291)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 515.348)"
          ></path>
          <path
            id="path292"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.445.445 0 1 1 .002-.89A.445.445 0 0 1 0 0"
            clipPath="url(#clipPath293)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 526.313)"
          ></path>
          <path
            id="path294"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath295)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 520.83)"
          ></path>
          <path
            id="path296"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath297)"
            transform="matrix(1.33333 0 0 -1.33333 2432.771 509.865)"
          ></path>
          <path
            id="path298"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath299)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 509.47)"
          ></path>
          <path
            id="path300"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 1 0-1.48A.74.74 0 0 1 0 0"
            clipPath="url(#clipPath301)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 498.504)"
          ></path>
          <path
            id="path302"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath303)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 503.987)"
          ></path>
          <path
            id="path304"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath305)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 514.953)"
          ></path>
          <path
            id="path306"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath307)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 520.436)"
          ></path>
          <path
            id="path308"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 0 1-.74-.74c0-.409.331-.737.74-.737s.74.328.74.737A.74.74 0 0 1 0 0"
            clipPath="url(#clipPath309)"
            transform="matrix(1.33333 0 0 -1.33333 2435.926 525.923)"
          ></path>
          <path
            id="path310"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.887.887 0 1 0 .001-1.775A.887.887 0 0 0 0 0"
            clipPath="url(#clipPath311)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 509.273)"
          ></path>
          <path
            id="path312"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.889.889 0 1 1 .002-1.778A.889.889 0 0 1 0 0"
            clipPath="url(#clipPath313)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 498.305)"
          ></path>
          <path
            id="path314"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.888.888 0 1 0 0-1.776A.888.888 0 0 0 0 0"
            clipPath="url(#clipPath315)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 503.79)"
          ></path>
          <path
            id="path316"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.888.888 0 1 0 0-1.776A.888.888 0 0 0 0 0"
            clipPath="url(#clipPath317)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 514.756)"
          ></path>
          <path
            id="path318"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.887.887 0 1 0 .001-1.775A.887.887 0 0 0 0 0"
            clipPath="url(#clipPath319)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 520.24)"
          ></path>
          <path
            id="path320"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.89.89 0 0 1-.888-.89c0-.491.398-.886.888-.886.491 0 .888.395.888.886A.89.89 0 0 1 0 0"
            clipPath="url(#clipPath321)"
            transform="matrix(1.33333 0 0 -1.33333 2439.477 525.724)"
          ></path>
          <path
            id="path322"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.275.275 0 0 1-.274-.274.274.274 0 0 1 .548 0A.274.274 0 0 1 0 0"
            clipPath="url(#clipPath323)"
            transform="matrix(1.33333 0 0 -1.33333 2416.126 496.133)"
          ></path>
          <path
            id="path324"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.273.273 0 1 1 0-.547c.151 0 .274.123.274.273A.273.273 0 0 1 0 0"
            clipPath="url(#clipPath325)"
            transform="matrix(1.33333 0 0 -1.33333 2416.126 492.202)"
          ></path>
          <path
            id="path326"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.41.41 0 1 0 0-.82A.41.41 0 0 0 0 0"
            clipPath="url(#clipPath327)"
            transform="matrix(1.33333 0 0 -1.33333 2419.04 495.95)"
          ></path>
          <path
            id="path328"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.411.411 0 0 1 0-.821A.411.411 0 0 1 0 0"
            clipPath="url(#clipPath329)"
            transform="matrix(1.33333 0 0 -1.33333 2419.04 492.02)"
          ></path>
          <path
            id="path330"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.684.684 0 1 1 0-1.367A.684.684 0 0 1 0 0"
            clipPath="url(#clipPath331)"
            transform="matrix(1.33333 0 0 -1.33333 2421.956 491.655)"
          ></path>
          <path
            id="path332"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.684.684 0 1 0 0-1.367A.684.684 0 0 0 0 0"
            clipPath="url(#clipPath333)"
            transform="matrix(1.33333 0 0 -1.33333 2421.956 495.586)"
          ></path>
          <path
            id="path334"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.82.82 0 0 1-.821-.822A.82.82 0 0 1 0-1.641.82.82 0 0 1 0 0"
            clipPath="url(#clipPath335)"
            transform="matrix(1.33333 0 0 -1.33333 2425.238 491.47)"
          ></path>
          <path
            id="path336"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.82.82 0 1 0 0-1.64A.82.82 0 0 0 0 0"
            clipPath="url(#clipPath337)"
            transform="matrix(1.33333 0 0 -1.33333 2425.238 495.404)"
          ></path>
          <path
            id="path338"
            fill="#777"
            fillOpacity="1"
            fillRule="nonzero"
            d="M37.02 0 21.094-26.448c-.574-.949-1.254-1.558-2.32-1.558-1.067 0-1.782.61-2.356 1.558L.528.001h5.519L18.586-21.21l6.152 10.347h-8.472L13.98-6.949H27.06l4.136 6.95zM55.03 0c7.782 0 13.453-6.082 13.453-14.097s-5.671-13.535-13.453-13.535H39.023V0ZM43.816-4.827v-17.976h11.215c4.969 0 8.625 3.726 8.625 8.93 0 5.214-3.656 9.046-8.625 9.046zM102.42.001 86.493-26.45c-.574-.949-1.254-1.558-2.32-1.558-1.067 0-1.781.61-2.356 1.558L65.927.001h5.52L83.984-21.21l6.153 10.347h-8.473L79.38-6.949h13.078l4.137 6.95Zm21.419-7.676c6.387 0 10.113-4.102 10.113-10.067 0-6.047-3.726-9.89-10.113-9.89H104.42V0h4.793v-22.805h14.625c3.387 0 5.402 2.015 5.402 5.203 0 3.117-2.015 5.25-5.402 5.25h-11.086v4.676zM150.105 0v-22.805h10.489v-4.828h-25.805v4.828h10.488V0Zm17.819 0v-27.633h-4.828V0Zm0 0"
            ariaLabel="ADAPTI"
            transform="matrix(1.33333 0 0 1.33333 2137.4 528.503)"
          ></path>
          <path
            id="path339"
            fill="#777"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-2.886-3.486-8.709 10.487-1.46 1.769.636.017 4.279.001c.143-.001.745.04.836-.007.05-.025.124-.136.163-.183l.429-.515L-4.5 5.409l2.678-3.213Z"
            clipPath="url(#clipPath340)"
            transform="matrix(1.33333 0 0 -1.33333 2383.129 502.973)"
          ></path>
          <path
            id="path341"
            fill="#777"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-6.005-.004-7.077 8.6 1.459 1.715 1.577 1.858c.256-.195.522-.609.74-.873l1.647-1.986 4.331-5.235Z"
            clipPath="url(#clipPath342)"
            transform="matrix(1.33333 0 0 -1.33333 2404.45 527.713)"
          ></path>
          <path
            id="path343"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-16.566-19.644-2.672-3.163-3.227-3.849-.52-.599c-.026-.028-.094-.124-.125-.138-.05-.024-.199 0-.258 0l-.825.001-4.804.006.382.464 7.484 8.837L-7.162-1.566-6.106-.33c.06.07.213.299.282.333C-5.736.047-.479 0 0 0"
            clipPath="url(#clipPath344)"
            transform="matrix(1.33333 0 0 -1.33333 2404.394 491.19)"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  );
}

export function CompanyLogoDark() {
  return (
    <SvgIcon sx={{ height: 80, width: 100, mr: 2 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="svg1"
        width="444.579"
        height="402.929"
        version="1.1"
        viewBox="0 0 444.579 402.929"
      >
        <defs id="defs1">
          <clipPath id="clipPath183" clipPathUnits="userSpaceOnUse">
            <path
              id="path183"
              d="M0 500h1000V0H0Z"
              transform="translate(-133.896 -238.589)"
            ></path>
          </clipPath>
          <clipPath id="clipPath185" clipPathUnits="userSpaceOnUse">
            <path
              id="path185"
              d="M0 500h1000V0H0Z"
              transform="translate(-366.524 -349.076)"
            ></path>
          </clipPath>
          <clipPath id="clipPath187" clipPathUnits="userSpaceOnUse">
            <path
              id="path187"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.17 -336.862)"
            ></path>
          </clipPath>
          <clipPath id="clipPath190" clipPathUnits="userSpaceOnUse">
            <path
              id="path190"
              d="M0 500h1000V0H0Z"
              transform="translate(-303.213 -113.341)"
            ></path>
          </clipPath>
          <clipPath id="clipPath192" clipPathUnits="userSpaceOnUse">
            <path
              id="path192"
              d="M0 500h1000V0H0Z"
              transform="translate(-303.213 -117.454)"
            ></path>
          </clipPath>
          <clipPath id="clipPath194" clipPathUnits="userSpaceOnUse">
            <path
              id="path194"
              d="M0 500h1000V0H0Z"
              transform="translate(-303.213 -121.566)"
            ></path>
          </clipPath>
          <clipPath id="clipPath196" clipPathUnits="userSpaceOnUse">
            <path
              id="path196"
              d="M0 500h1000V0H0Z"
              transform="translate(-303.213 -125.678)"
            ></path>
          </clipPath>
          <clipPath id="clipPath198" clipPathUnits="userSpaceOnUse">
            <path
              id="path198"
              d="M0 500h1000V0H0Z"
              transform="translate(-303.213 -105.114)"
            ></path>
          </clipPath>
          <clipPath id="clipPath200" clipPathUnits="userSpaceOnUse">
            <path
              id="path200"
              d="M0 500h1000V0H0Z"
              transform="translate(-303.213 -109.229)"
            ></path>
          </clipPath>
          <clipPath id="clipPath202" clipPathUnits="userSpaceOnUse">
            <path
              id="path202"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.578 -121.714)"
            ></path>
          </clipPath>
          <clipPath id="clipPath204" clipPathUnits="userSpaceOnUse">
            <path
              id="path204"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.578 -125.826)"
            ></path>
          </clipPath>
          <clipPath id="clipPath206" clipPathUnits="userSpaceOnUse">
            <path
              id="path206"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.578 -113.49)"
            ></path>
          </clipPath>
          <clipPath id="clipPath208" clipPathUnits="userSpaceOnUse">
            <path
              id="path208"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.578 -105.265)"
            ></path>
          </clipPath>
          <clipPath id="clipPath210" clipPathUnits="userSpaceOnUse">
            <path
              id="path210"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.578 -109.377)"
            ></path>
          </clipPath>
          <clipPath id="clipPath212" clipPathUnits="userSpaceOnUse">
            <path
              id="path212"
              d="M0 500h1000V0H0Z"
              transform="translate(-305.578 -117.602)"
            ></path>
          </clipPath>
          <clipPath id="clipPath214" clipPathUnits="userSpaceOnUse">
            <path
              id="path214"
              d="M0 500h1000V0H0Z"
              transform="translate(-307.944 -117.898)"
            ></path>
          </clipPath>
          <clipPath id="clipPath216" clipPathUnits="userSpaceOnUse">
            <path
              id="path216"
              d="M0 500h1000V0H0Z"
              transform="translate(-307.944 -126.122)"
            ></path>
          </clipPath>
          <clipPath id="clipPath218" clipPathUnits="userSpaceOnUse">
            <path
              id="path218"
              d="M0 500h1000V0H0Z"
              transform="translate(-307.944 -122.01)"
            ></path>
          </clipPath>
          <clipPath id="clipPath220" clipPathUnits="userSpaceOnUse">
            <path
              id="path220"
              d="M0 500h1000V0H0Z"
              transform="translate(-307.944 -113.785)"
            ></path>
          </clipPath>
          <clipPath id="clipPath222" clipPathUnits="userSpaceOnUse">
            <path
              id="path222"
              d="M0 500h1000V0H0Z"
              transform="translate(-307.944 -109.673)"
            ></path>
          </clipPath>
          <clipPath id="clipPath224" clipPathUnits="userSpaceOnUse">
            <path
              id="path224"
              d="M0 500h1000V0H0Z"
              transform="translate(-307.944 -105.558)"
            ></path>
          </clipPath>
          <clipPath id="clipPath226" clipPathUnits="userSpaceOnUse">
            <path
              id="path226"
              d="M0 500h1000V0H0Z"
              transform="translate(-310.608 -118.045)"
            ></path>
          </clipPath>
          <clipPath id="clipPath228" clipPathUnits="userSpaceOnUse">
            <path
              id="path228"
              d="M0 500h1000V0H0Z"
              transform="translate(-310.608 -126.271)"
            ></path>
          </clipPath>
          <clipPath id="clipPath230" clipPathUnits="userSpaceOnUse">
            <path
              id="path230"
              d="M0 500h1000V0H0Z"
              transform="translate(-310.608 -122.158)"
            ></path>
          </clipPath>
          <clipPath id="clipPath232" clipPathUnits="userSpaceOnUse">
            <path
              id="path232"
              d="M0 500h1000V0H0Z"
              transform="translate(-310.608 -113.933)"
            ></path>
          </clipPath>
          <clipPath id="clipPath234" clipPathUnits="userSpaceOnUse">
            <path
              id="path234"
              d="M0 500h1000V0H0Z"
              transform="translate(-310.608 -109.82)"
            ></path>
          </clipPath>
          <clipPath id="clipPath236" clipPathUnits="userSpaceOnUse">
            <path
              id="path236"
              d="M0 500h1000V0H0Z"
              transform="translate(-310.608 -105.707)"
            ></path>
          </clipPath>
          <clipPath id="clipPath238" clipPathUnits="userSpaceOnUse">
            <path
              id="path238"
              d="M0 500h1000V0H0Z"
              transform="translate(-293.094 -127.9)"
            ></path>
          </clipPath>
          <clipPath id="clipPath240" clipPathUnits="userSpaceOnUse">
            <path
              id="path240"
              d="M0 500h1000V0H0Z"
              transform="translate(-293.094 -130.849)"
            ></path>
          </clipPath>
          <clipPath id="clipPath242" clipPathUnits="userSpaceOnUse">
            <path
              id="path242"
              d="M0 500h1000V0H0Z"
              transform="translate(-295.28 -128.037)"
            ></path>
          </clipPath>
          <clipPath id="clipPath244" clipPathUnits="userSpaceOnUse">
            <path
              id="path244"
              d="M0 500h1000V0H0Z"
              transform="translate(-295.28 -130.985)"
            ></path>
          </clipPath>
          <clipPath id="clipPath246" clipPathUnits="userSpaceOnUse">
            <path
              id="path246"
              d="M0 500h1000V0H0Z"
              transform="translate(-297.467 -131.26)"
            ></path>
          </clipPath>
          <clipPath id="clipPath248" clipPathUnits="userSpaceOnUse">
            <path
              id="path248"
              d="M0 500h1000V0H0Z"
              transform="translate(-297.467 -128.31)"
            ></path>
          </clipPath>
          <clipPath id="clipPath250" clipPathUnits="userSpaceOnUse">
            <path
              id="path250"
              d="M0 500h1000V0H0Z"
              transform="translate(-299.929 -131.397)"
            ></path>
          </clipPath>
          <clipPath id="clipPath252" clipPathUnits="userSpaceOnUse">
            <path
              id="path252"
              d="M0 500h1000V0H0Z"
              transform="translate(-299.929 -128.447)"
            ></path>
          </clipPath>
          <clipPath id="clipPath255" clipPathUnits="userSpaceOnUse">
            <path
              id="path255"
              d="M0 500h1000V0H0Z"
              transform="translate(-268.347 -122.77)"
            ></path>
          </clipPath>
          <clipPath id="clipPath257" clipPathUnits="userSpaceOnUse">
            <path
              id="path257"
              d="M0 500h1000V0H0Z"
              transform="translate(-284.338 -104.215)"
            ></path>
          </clipPath>
          <clipPath id="clipPath259" clipPathUnits="userSpaceOnUse">
            <path
              id="path259"
              d="M0 500h1000V0H0Z"
              transform="translate(-284.295 -131.607)"
            ></path>
          </clipPath>
          <linearGradient
            id="linearGradient177"
            x1="0"
            x2="1"
            y1="0"
            y2="0"
            gradientTransform="matrix(187.64043 0 0 -187.64043 141.721 237.972)"
            gradientUnits="userSpaceOnUse"
            spreadMethod="pad"
          >
            <stop
              id="stop174"
              offset="0"
              stopColor="#07a1e5"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop175"
              offset="0.511"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop176"
              offset="0.763"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop177"
              offset="1"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
          </linearGradient>
          <linearGradient
            id="linearGradient181"
            x1="0"
            x2="1"
            y1="0"
            y2="0"
            gradientTransform="matrix(187.64565 0 0 -187.64565 170.898 324.986)"
            gradientUnits="userSpaceOnUse"
            spreadMethod="pad"
          >
            <stop
              id="stop178"
              offset="0"
              stopColor="#07a1e5"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop179"
              offset="0.511"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop180"
              offset="0.763"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
            <stop
              id="stop181"
              offset="1"
              stopColor="#0c42bc"
              stopOpacity="1"
            ></stop>
          </linearGradient>
          <color-profile
            xlinkHref="data:application/vnd.iccprofile;base64,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"
            id="color-profile1"
            name="sRGB IEC61966-2.1"
          ></color-profile>
        </defs>
        <g
          id="layer-MC0"
          stroke="none"
          transform="translate(-1464.552 -125.575)"
        >
          <path
            id="path177"
            fill="url(#linearGradient177)"
            d="M145.946 318.006c-2.482-.524-4.225-2.769-4.225-5.306v-90.668a5.44 5.44 0 0 1 2.722-4.714l10.406-6.007 11.721-6.769 80.843-46.673a5.44 5.44 0 0 1 5.442 0l75.392 43.529c1.655.955 1.418 3.414-.388 4.036l-6.668 2.297a78 78 0 0 0-16.674 8.094c-.211.137-.413.291-.624.431l-51.038-29.47a5.44 5.44 0 0 0-5.442 0l-51.043 29.47-7.697 4.444-19.188 11.078a5.44 5.44 0 0 0-2.72 4.713v75.914c0 2.492-1.691 4.681-4.108 5.286a37.3 37.3 0 0 1-9.048 1.113c-2.627 0-5.189-.277-7.663-.798"
            transform="matrix(1.33333 0 0 -1.33333 1353.333 666.667)"
          ></path>
          <path
            id="path181"
            fill="url(#linearGradient181)"
            d="m247.413 405.09-75.401-43.534c-1.655-.955-1.418-3.414.389-4.035l6.675-2.297a77.7 77.7 0 0 0 16.674-8.097c.209-.135.41-.289.617-.425l51.046 29.469a5.44 5.44 0 0 0 5.442 0l51.043-29.468 7.696-4.445 19.184-11.075a5.44 5.44 0 0 0 2.721-4.713v-79.903c.324-.122.642-.255.969-.367a37.3 37.3 0 0 1 12.186-2.046c2.629 0 5.192.277 7.666.8 2.482.524 4.224 2.769 4.224 5.305v90.668a5.45 5.45 0 0 1-2.721 4.714l-10.405 6.006-11.723 6.77-80.84 46.673a5.438 5.438 0 0 1-5.442 0"
            transform="matrix(1.33333 0 0 -1.33333 1353.333 666.667)"
          ></path>
          <path
            id="path182"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a3.72 3.72 0 0 1-1.917 3.269c-14.004 7.675-23.522 22.556-23.522 39.62 0 17.835 10.394 33.281 25.439 40.615a45 45 0 0 0 7.825 2.938 45 45 0 0 0 11.888 1.599c4.47 0 8.881-.695 13.155-2 .531-.162 1.066-.295 1.589-.476a45 45 0 0 0 6.238-2.723 46 46 0 0 0 3.383-1.949 46 46 0 0 0 4.912-3.646L86.425 49.43a3.76 3.76 0 0 1 4.481-.001l14.699 10.91c2.024 1.502 2.024 4.532 0 6.035L64.893 96.595a71 71 0 0 1-2.843 2.239 70 70 0 0 1-4.432 3.123 67 67 0 0 1-2.845 1.711 69.6 69.6 0 0 1-12.148 5.57 70 70 0 0 1-21.673 3.821c-.413.006-.826.025-1.239.025a70 70 0 0 1-18.866-2.596c-29.57-8.264-51.329-35.429-51.329-67.599 0-32.169 20.761-59.334 50.329-67.597l.153.491Z"
            clipPath="url(#clipPath183)"
            transform="matrix(1.33333 0 0 -1.33333 1531.862 348.549)"
          ></path>
          <path
            id="path184"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-.155-.489v-24.219c0-1.357.727-2.618 1.917-3.27 14.004-7.675 23.522-22.556 23.522-39.621 0-17.831-10.394-33.279-25.439-40.611a44.6 44.6 0 0 0-7.825-2.938 45 45 0 0 0-11.89-1.601c-4.472 0-8.881.697-13.155 1.999-.527.163-1.062.296-1.585.475a45 45 0 0 0-6.24 2.725 44 44 0 0 0-3.378 1.947 45 45 0 0 0-4.911 3.646L-86.58-74.138a3.76 3.76 0 0 1-4.481.001l-14.7-10.91c-2.025-1.503-2.025-4.533-.001-6.035l40.71-30.216c.921-.777 1.882-1.513 2.843-2.244a72 72 0 0 1 4.434-3.125 69 69 0 0 1 2.845-1.709 70 70 0 0 1 12.152-5.573 70 70 0 0 1 21.668-3.816c.414-.009.827-.028 1.24-.028a70 70 0 0 1 18.866 2.597c29.57 8.263 51.329 35.428 51.329 67.597S29.568-8.266 0 0"
            clipPath="url(#clipPath185)"
            transform="matrix(1.33333 0 0 -1.33333 1842.032 201.231)"
          ></path>
          <path
            id="path186"
            fill="#fe9900"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0 20.467-11.45c1.511-.846 1.651-2.966.265-4.003l-129.043-96.546a2.39 2.39 0 0 0-2.677-.128l-19.055 11.609a2.393 2.393 0 0 0-.197 3.952L-2.609-.179A2.39 2.39 0 0 0 0 0"
            clipPath="url(#clipPath187)"
            transform="matrix(1.33333 0 0 -1.33333 1760.227 217.517)"
          ></path>
          <path
            id="path188"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M16.08.001v-22.805h10.487v-4.828H.763v4.828H11.25V.001Zm37.423 0v-4.828h-19.91v-17.977h19.875v-4.828H28.8V.001Zm-1.067-12.012v-4.066H37.132v4.066zM84.291.001v-4.828H69.314c-4.98 0-8.59-3.832-8.59-9.047 0-5.238 3.645-8.93 8.59-8.93h14.977v-4.828H69.314c-7.71 0-13.418 5.403-13.418 13.535C55.896-6.08 61.603.001 69.314.001zm30.012.117v-27.75h-4.828v11.438H95.576v4.3h13.899V.118Zm-22.23 0v-27.75h-4.829V.118zm0 0"
            ariaLabel="TECH"
            transform="matrix(1.33333 0 0 1.33333 1752.547 528.092)"
          ></path>
          <path
            id="path189"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath190)"
            transform="matrix(1.33333 0 0 -1.33333 1757.617 515.545)"
          ></path>
          <path
            id="path191"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath192)"
            transform="matrix(1.33333 0 0 -1.33333 1757.617 510.062)"
          ></path>
          <path
            id="path193"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.297.297 0 0 1-.296-.296A.297.297 0 1 1 0 0"
            clipPath="url(#clipPath194)"
            transform="matrix(1.33333 0 0 -1.33333 1757.617 504.579)"
          ></path>
          <path
            id="path195"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 0-.592A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath196)"
            transform="matrix(1.33333 0 0 -1.33333 1757.617 499.096)"
          ></path>
          <path
            id="path197"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 0-.592A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath198)"
            transform="matrix(1.33333 0 0 -1.33333 1757.617 526.515)"
          ></path>
          <path
            id="path199"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.295.295 0 1 1 .296-.296A.297.297 0 0 1 0 0"
            clipPath="url(#clipPath200)"
            transform="matrix(1.33333 0 0 -1.33333 1757.617 521.028)"
          ></path>
          <path
            id="path201"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath202)"
            transform="matrix(1.33333 0 0 -1.33333 1760.771 504.381)"
          ></path>
          <path
            id="path203"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.443.443 0 1 1 0-.888A.445.445 0 0 1 0 0"
            clipPath="url(#clipPath204)"
            transform="matrix(1.33333 0 0 -1.33333 1760.771 498.898)"
          ></path>
          <path
            id="path205"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath206)"
            transform="matrix(1.33333 0 0 -1.33333 1760.771 515.348)"
          ></path>
          <path
            id="path207"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.445.445 0 1 1 .002-.89A.445.445 0 0 1 0 0"
            clipPath="url(#clipPath208)"
            transform="matrix(1.33333 0 0 -1.33333 1760.771 526.313)"
          ></path>
          <path
            id="path209"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath210)"
            transform="matrix(1.33333 0 0 -1.33333 1760.771 520.83)"
          ></path>
          <path
            id="path211"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.444.444 0 1 0 0-.889A.444.444 0 0 0 0 0"
            clipPath="url(#clipPath212)"
            transform="matrix(1.33333 0 0 -1.33333 1760.771 509.865)"
          ></path>
          <path
            id="path213"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath214)"
            transform="matrix(1.33333 0 0 -1.33333 1763.926 509.47)"
          ></path>
          <path
            id="path215"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 1 0-1.48A.74.74 0 0 1 0 0"
            clipPath="url(#clipPath216)"
            transform="matrix(1.33333 0 0 -1.33333 1763.926 498.504)"
          ></path>
          <path
            id="path217"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath218)"
            transform="matrix(1.33333 0 0 -1.33333 1763.926 503.987)"
          ></path>
          <path
            id="path219"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath220)"
            transform="matrix(1.33333 0 0 -1.33333 1763.926 514.953)"
          ></path>
          <path
            id="path221"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 1 0 0-1.48A.74.74 0 0 0 0 0"
            clipPath="url(#clipPath222)"
            transform="matrix(1.33333 0 0 -1.33333 1763.926 520.436)"
          ></path>
          <path
            id="path223"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.74.74 0 0 1-.74-.74c0-.409.331-.737.74-.737s.74.328.74.737A.74.74 0 0 1 0 0"
            clipPath="url(#clipPath224)"
            transform="matrix(1.33333 0 0 -1.33333 1763.926 525.923)"
          ></path>
          <path
            id="path225"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.887.887 0 1 0 .001-1.775A.887.887 0 0 0 0 0"
            clipPath="url(#clipPath226)"
            transform="matrix(1.33333 0 0 -1.33333 1767.477 509.273)"
          ></path>
          <path
            id="path227"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.889.889 0 1 1 .002-1.778A.889.889 0 0 1 0 0"
            clipPath="url(#clipPath228)"
            transform="matrix(1.33333 0 0 -1.33333 1767.477 498.305)"
          ></path>
          <path
            id="path229"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.888.888 0 1 0 0-1.776A.888.888 0 0 0 0 0"
            clipPath="url(#clipPath230)"
            transform="matrix(1.33333 0 0 -1.33333 1767.477 503.79)"
          ></path>
          <path
            id="path231"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.888.888 0 1 0 0-1.776A.888.888 0 0 0 0 0"
            clipPath="url(#clipPath232)"
            transform="matrix(1.33333 0 0 -1.33333 1767.477 514.756)"
          ></path>
          <path
            id="path233"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.887.887 0 1 0 .001-1.775A.887.887 0 0 0 0 0"
            clipPath="url(#clipPath234)"
            transform="matrix(1.33333 0 0 -1.33333 1767.477 520.24)"
          ></path>
          <path
            id="path235"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.89.89 0 0 1-.888-.89c0-.491.398-.886.888-.886.491 0 .888.395.888.886A.89.89 0 0 1 0 0"
            clipPath="url(#clipPath236)"
            transform="matrix(1.33333 0 0 -1.33333 1767.477 525.724)"
          ></path>
          <path
            id="path237"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.275.275 0 0 1-.274-.274.274.274 0 0 1 .548 0A.274.274 0 0 1 0 0"
            clipPath="url(#clipPath238)"
            transform="matrix(1.33333 0 0 -1.33333 1744.126 496.133)"
          ></path>
          <path
            id="path239"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.273.273 0 1 1 0-.547c.151 0 .274.123.274.273A.273.273 0 0 1 0 0"
            clipPath="url(#clipPath240)"
            transform="matrix(1.33333 0 0 -1.33333 1744.126 492.202)"
          ></path>
          <path
            id="path241"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.41.41 0 1 0 0-.82A.41.41 0 0 0 0 0"
            clipPath="url(#clipPath242)"
            transform="matrix(1.33333 0 0 -1.33333 1747.04 495.95)"
          ></path>
          <path
            id="path243"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.411.411 0 0 1 0-.821A.411.411 0 0 1 0 0"
            clipPath="url(#clipPath244)"
            transform="matrix(1.33333 0 0 -1.33333 1747.04 492.02)"
          ></path>
          <path
            id="path245"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.684.684 0 1 1 0-1.367A.684.684 0 0 1 0 0"
            clipPath="url(#clipPath246)"
            transform="matrix(1.33333 0 0 -1.33333 1749.956 491.655)"
          ></path>
          <path
            id="path247"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.684.684 0 1 0 0-1.367A.684.684 0 0 0 0 0"
            clipPath="url(#clipPath248)"
            transform="matrix(1.33333 0 0 -1.33333 1749.956 495.586)"
          ></path>
          <path
            id="path249"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.82.82 0 0 1-.821-.822A.82.82 0 0 1 0-1.641a.82.82 0 0 1 .821.819A.82.82 0 0 1 0 0"
            clipPath="url(#clipPath250)"
            transform="matrix(1.33333 0 0 -1.33333 1753.238 491.47)"
          ></path>
          <path
            id="path251"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="M0 0a.82.82 0 1 0 0-1.642A.82.82 0 0 0 0 0"
            clipPath="url(#clipPath252)"
            transform="matrix(1.33333 0 0 -1.33333 1753.238 495.404)"
          ></path>
          <path
            id="path253"
            fill="#fff"
            fillOpacity="1"
            fillRule="nonzero"
            d="M37.019 0 21.093-26.448c-.574-.949-1.254-1.558-2.32-1.558s-1.781.61-2.356 1.558L.527.001h5.52L18.584-21.21l6.153 10.347h-8.473L13.98-6.949h13.078l4.137 6.95zm18.012 0c7.781 0 13.453-6.082 13.453-14.097S62.812-27.632 55.03-27.632H39.023V0ZM43.816-4.827v-17.976H55.03c4.969 0 8.625 3.726 8.625 8.93 0 5.214-3.656 9.046-8.625 9.046zM102.418.001 86.493-26.45c-.575-.949-1.254-1.558-2.32-1.558-1.067 0-1.782.61-2.356 1.558L65.927.001h5.519L83.985-21.21l6.152 10.347h-8.472l-2.286 3.914h13.079l4.136 6.95Zm21.42-7.676c6.386 0 10.113-4.102 10.113-10.067 0-6.047-3.727-9.89-10.114-9.89H104.42V0h4.793v-22.805h14.625c3.387 0 5.403 2.015 5.403 5.203 0 3.117-2.016 5.25-5.403 5.25h-11.086v4.676zM150.104 0v-22.805h10.488v-4.828H134.79v4.828h10.488V0Zm17.818 0v-27.633h-4.828V0Zm0 0"
            ariaLabel="ADAPTI"
            transform="matrix(1.33333 0 0 1.33333 1465.4 528.503)"
          ></path>
          <path
            id="path254"
            fill="#fefefe"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-2.886-3.486-8.709 10.487-1.46 1.769.636.017 4.279.001c.143-.001.745.04.836-.007.05-.025.124-.136.163-.183l.429-.515L-4.5 5.409l2.678-3.213Z"
            clipPath="url(#clipPath255)"
            transform="matrix(1.33333 0 0 -1.33333 1711.129 502.973)"
          ></path>
          <path
            id="path256"
            fill="#fefefe"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-6.005-.004-7.077 8.6 1.459 1.715 1.577 1.858c.256-.195.522-.609.74-.873l1.647-1.986 4.331-5.235Z"
            clipPath="url(#clipPath257)"
            transform="matrix(1.33333 0 0 -1.33333 1732.45 527.713)"
          ></path>
          <path
            id="path258"
            fill="#01aef0"
            fillOpacity="1"
            fillRule="nonzero"
            d="m0 0-16.566-19.644-2.672-3.163-3.227-3.849-.52-.599c-.026-.028-.094-.124-.125-.138-.05-.024-.199 0-.258 0l-.825.001-4.804.006.382.464 7.484 8.837L-7.162-1.566-6.106-.33c.06.07.213.299.282.333C-5.736.047-.479 0 0 0"
            clipPath="url(#clipPath259)"
            transform="matrix(1.33333 0 0 -1.33333 1732.394 491.19)"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  );
}

export function FacebookIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.68 15.92C2.88 15.24 0 11.96 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 11.96 13.12 15.24 9.32 15.92L8.88 15.56H7.12L6.68 15.92Z"
          fill="url(#paint0_linear_795_116)"
        />
        <path
          d="M11.12 10.2391L11.48 7.99914H9.36V6.43914C9.36 5.79914 9.6 5.31914 10.56 5.31914H11.6V3.27914C11.04 3.19914 10.4 3.11914 9.84 3.11914C8 3.11914 6.72 4.23914 6.72 6.23914V7.99914H4.72V10.2391H6.72V15.8791C7.16 15.9591 7.6 15.9991 8.04 15.9991C8.48 15.9991 8.92 15.9591 9.36 15.8791V10.2391H11.12Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_795_116"
            x1="8"
            y1="0"
            x2="8"
            y2="15.9991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1AAFFF" />
            <stop offset="1" stopColor="#0163E0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GoogleIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54545H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z"
          fill="#4285F4"
        />
        <path
          d="M8 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98545 12.5309 9.07636 12.8218 8 12.8218C5.92 12.8218 4.15273 11.4182 3.52 9.52727H0.858182V11.5927C2.17455 14.2036 4.87273 16 8 16Z"
          fill="#34A853"
        />
        <path
          d="M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.46909 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70545 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z"
          fill="#FBBC05"
        />
        <path
          d="M8 3.18545C9.17818 3.18545 10.2255 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 8 0C4.87273 0 2.17455 1.79636 0.858182 4.41455L3.52 6.48C4.15273 4.58909 5.92 3.18545 8 3.18545Z"
          fill="#EA4335"
        />
      </svg>
    </SvgIcon>
  );
}

export function SSOIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-log-in-icon lucide-log-in"
      >
        <path d="m10 17 5-5-5-5" />
        <path d="M15 12H3" />
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      </svg>
    </SvgIcon>
  );
}
